<template>
  <v-alert
      class="alert-custom"
      v-bind:type="alert.type"
      v-if="alert.show"
  dismissible
  @input="clear"
  >
  {{ alert.message }}
  </v-alert>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      alert: (state) => state.alerts,
    }),
  },

    watch: {
        '$store.state.alerts.show'(value){
            if (value){
                window.scrollTo(0,0)

                setTimeout(()=> {
                    this.clear()
                }, 6000);
            }
        },
    },
    methods: {
        ...mapActions('alerts', ['clear']),
    },
};
</script>

<style scoped>

.v-alert {
  z-index: 10;
  position: fixed;
  top: 70px;
  right: 0px;
  min-width: 30%;
  border-radius: 8px;
  opacity: 0;
  transform: translateX(100%);
  animation: slide-in 0.6s forwards;
  animation-delay: 600ms;
}

.alert-custom {
  border-radius: 8px;
}

@keyframes slide-in {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0); 
    opacity: 1;
  }
}
</style>
